<template>
    <div id="InformationVideo" class="w2">
        <h1 class="h1 center" id="information-video-h1">影音專區</h1>
        <video autoplay controls controlsList="nodownload" ref="video">
            <source :src="videoLinks[activeIndex].videoUrl" type="video/mp4" />
        </video>
        <h2 class="f32 f20-mb">{{ videoLinks[activeIndex].title }}</h2>

        <ul>
            <li
                v-for="(item, index) in videoLinks"
                :key="'video-menu-' + index"
                :class="{ activated: activeIndex === index }"
                @click="changeVideo(index)"
                @keypress.enter="changeVideo(index)"
                tabindex="0"
                role="button"
            >
                <img :src="item.imgUrl" :alt="item.title + ' thumbnail'" />
                <h3 class="f14 f14-mb">{{ item.title }}</h3>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'InformationVideo',
}
</script>
<script setup>
import { ref } from 'vue'
import getVideoLinks from '@/data/getVideoLinks.js'
const video = ref(null)
const activeIndex = ref(0)
function changeVideo(index) {
    activeIndex.value = index
    const offsetTop = document.getElementById('information-video-h1').offsetTop
    window.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: 'smooth',
    })
    video.value.load()
}
const { videoLinks } = getVideoLinks()
</script>
<style lang="scss" scoped>
h2 {
    color: $gray4;
    font-weight: 700;
    text-align: center;
    border-bottom: 1px solid $grayB;
    @media screen and (min-width: 768px) {
        line-height: 2em;
        padding-bottom: 50px;
    }
    @media screen and (max-width: 767px) {
        line-height: 1.5em;
        padding: 15px 20px 20px;
    }
}
video {
    width: 100%;
}
ul {
    display: grid;
    @media screen and (min-width: 768px) {
        margin: 50px 0 80px;
        grid-template: auto / repeat(4, 1fr);
        grid-gap: 20px;
    }
    @media screen and (max-width: 767px) {
        margin: 20px 10px 50px;
        grid-template: auto / repeat(2, 1fr);
        grid-gap: 10px;
    }
}
li {
    position: relative;
    box-shadow: $shadow1;
    cursor: pointer;
    img {
        width: 100%;
        object-fit: cover;
    }
    h3 {
        padding: 5px 10px 10px;
    }
    &.activated:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border: 5px solid $theme2;
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (max-width: 767px) {
        h3 {
            line-height: 1.3em;
        }
    }
}
</style>
